import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'fuzzyAutocompleteHighlightPipe' })
export class FuzzyAutocompleteHighlightPipe implements PipeTransform {
  transform(suggestionTerm: string, searchTerm: string | null | undefined, options?: { inverted?: boolean }) {
    if (!searchTerm || !suggestionTerm) return suggestionTerm;

    const searchIndex = suggestionTerm.toLowerCase().indexOf(searchTerm.toLowerCase());
    if (searchIndex === -1) return suggestionTerm;

    const start = suggestionTerm.slice(0, searchIndex);
    const match = suggestionTerm.slice(searchIndex, searchIndex + searchTerm.length);
    const end = suggestionTerm.slice(searchIndex + searchTerm.length);
    let htmlElement;
    if (options?.inverted) {
      htmlElement = `${start}<strong>${match}</strong>${end}`;
    } else {
      htmlElement = `<strong>${start}</strong>${match}<strong>${end}</strong>`;
    }
    return this.sanitizer.sanitize(SecurityContext.HTML, htmlElement);
  }

  constructor(private sanitizer: DomSanitizer) {}
}
